// @ts-ignore
import { makeStyles } from "@material-ui/core";
import { createStyles } from "@material-ui/core/styles";
import { theme } from "config/theme";
import { fadeInDown } from "react-animations";
import styled, { keyframes } from "styled-components";

export const FadeInDownAnimation = keyframes`${fadeInDown}`;

export const useTourStyles = makeStyles(() =>
  createStyles({
    stepperStyled: {
      backgroundColor: "transparent",
      [theme.breakpoints.down("xs")]: {
        backgroundColor: "transparent",
        padding: "10px",
        width: "110vw",
        right: "50px",
        position: "relative",
      },
    },
    stepLabelStyled: {
      [theme.breakpoints.down("xs")]: {
        "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
          marginTop: "6px",
        },
        textAlign: "center",
      },
    },
    iconStyleTour: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: -2,
        writingMode: "vertical-lr",
      },
    },
  })
);

export const MainContainer = styled("div")`
  width: 100%;
  display: flex;
  margin-bottom: 0;
  background-color: #f5f6f8;
`;
export const MainMadContainer = styled("div")`
  width: 100%;
  display: flex;
  margin-bottom: 0;
  background-color: #f5f6f8;
`;
export const RootMadContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  height: 91vh;
  padding: 16px;
  border-radius: 15px;
  ${theme.breakpoints.down("xs")} {
    background-color: inherit;
    overflow-x: unset;
    margin-left: -5px;
  }
`;

export const RootTourContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  height: 91vh;
  padding: 16px;
  border-radius: 15px;
  ${theme.breakpoints.down("xs")} {
    overflow-x: unset;
    height: 95vh;
    border-radius: 5px;
    margin-left: -5px;
    margin-top: -30px;
    width: 100vw;
  }
`;

export const RootNTContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  height: 91vh;
  padding: 16px;
  border-radius: 15px;
  ${theme.breakpoints.down("xs")} {
    overflow-x: unset;
    height: 95vh;
    border-radius: 5px;
    margin-left: -5px;
    margin-top: -30px;
    width: 100vw;
  }
`;

export const StepperContainer = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const HeaderContainer = styled("div")`
  display: flex;
  grid-template-columns: 0fr 1fr;
  padding: 7px;
  ${theme.breakpoints.down("xs")} {
    margin-left: -30px;
    margin-top: 73px;
  }
`;
export const HeaderMadContainer = styled("div")`
  display: grid;
  grid-template-columns: 0fr 1fr;
  padding: 7px;
  ${theme.breakpoints.down("xs")} {
    padding: 0;
    margin-left: -30px;
    margin-top: 49px;
  }
`;
export const TitleContainer = styled("div")`
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-top: 9px;
  margin-left: 25px;
  ${theme.breakpoints.down("xs")} {
    font-size: 13px;
    font-family: Montserrat;
    margin-left: -6px;
    margin-top: 22px;
    text-align: start;
  }
`;
export const MadTitleContainer = styled("div")`
  text-align: center;
  font-size: 24px;
  margin-left: -100px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${(props) => props.color || "#1a224b"};
  padding: 10px;
  ${theme.breakpoints.down("xs")} {
    font-size: 16px;
    font-family: Montserrat;
    margin-left: -25px;
    margin-top: 6px;
  }
`;
export const BackButton = styled("div")`
  background-color: #399ebf;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 6px;
  margin-right: 10px;
  height: 40px;
  cursor: pointer;
  justify-content: center;
  color: #fff;
  font-size: 24pt;
  position: relative;
  z-index: 1;
  ${theme.breakpoints.down("xs")} {
    margin-left: 28px;
    position: relative;
    width: 80px;
    height: 40px;
    margin-top: 8px;
  }
`;

export const ExitText = styled("p")`
  font-size: 12pt;
  font-weight: bold;
  margin-right: 1vw;
  ${theme.breakpoints.down("xs")} {
    font-size: 11pt;
    font-weight: bold;
    margin-right: 1vw;
  }
`;

export const ContainerFormStep = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 5;
  overflow: auto;
  ${theme.breakpoints.down("xs")} {
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
    hoverflow-x: hidden;
  }
`;
export const ContainerMadFormStep = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 5;
  overflow-y: auto;
  ${theme.breakpoints.down("xs")} {
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
  }
`;

export const ContainerTourFormStep = styled("div")`
  width: auto;
  display: flex;
  justify-content: center;
  flex: 5;
  overflow-y: auto;
`;

export interface FormStepProps {
  activeStep?: number;
}
export const MadFormStep = styled("div")<FormStepProps>`
  width: ${({ activeStep }) => (activeStep === 1 && "60%") || (activeStep === 2 && "50%") || "100%"};
  display: flex;
  flex-direction: column;
  justifycontent: space-between;
  min-height: 400px;
  padding: 20px;
  border-radius: 14px;
  ${theme.breakpoints.down("xs")} {
    padding: 20px;
    justifycontent: space-between;
    width: 100%;
  }
`;

export const FormStep = styled("div")<FormStepProps>`
  width: ${({ activeStep }) => (activeStep === 1 && "60%") || (activeStep === 2 && "50%") || "100%"};
  display: flex;
  flex-direction: column;
  justifycontent: space-between;
  padding: 20px;
  border-radius: 14px;
  ${theme.breakpoints.down("xs")} {
    width: 100%;
    padding: 5px;
    margin-top: 12px;
  }
`;

export const TitleStep = styled("div")`
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #399ebf;
  display: flex;
  align-items: center;
  margin-left: 1rem;
  margin-bottom: 1rem;
  ${theme.breakpoints.down("xs")} {
    margin-right: 2rem;
    font-size: 12px;
  }
`;

export const SubTitleStep = styled("div")`
  text-align: left;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #98989a;
  padding: 10px;
`;

export const ContainerRadioElement = styled("span")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleRadio = styled("span")`
  margin-right: 10px;
  font-weight: bold;
  color: #757a93;
`;

export const DescriptionRadio = styled("span")`
  width: 259.8px;
  height: 22px;
  margin: 1.3px 96.2px 0 0;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.79;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  ${theme.breakpoints.down("xs")} {
    font-size: 12px;
    text-align: justify;
  }
`;

export const ContainerButtonsStep = styled("div")`
  text-align: end;
  position: relative;
  display: flex;
  ${theme.breakpoints.down("xs")} {
    display: flex;
    text-align: center;
    top: 10px;
  }
`;
export const ContainerBottomForm = styled("div")`
  display: block;
  width: 100%;
  ${theme.breakpoints.down("xs")} {
    margin-bottom: 30px;
    margin-right: 18px;
  }
`;

export const Button = styled("button")`
  width: 125px;
  height: 45px;
  margin: 0 0 0 24px;
  padding: 13px 46px;
  border-radius: 4px;
  background-color: #399ebf;
  color: white;
  cursor: pointer;
  border: 1px solid #399ebf;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const InformationsTerms = styled("div")`
  position: absolute;
  width: 40%;
  font-size: 15px;
  color: #4f4f4f;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  z-index: 998;
  ${theme.breakpoints.down("xs")} {
    display: none;
  }
`;
export const ClickableInformationsTerms = styled("small")`
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  z-index: 998;
  &:hover {
    color: #399ebf;
  }
`;

export const ContainerCounter = styled("div")`
  display: flex;
  margin: 5px;
  align-items: center;
`;

export const OperationButton = styled("span")`
  border-radius: 3px;
  margin: 0 2.7px 0 0;
  border: solid 1px ${(props) => (props["aria-disabled"] ? "#399ebf" : "#399ebf")};
  width: 28.8px;
  height: 28.8px;
  flex-grow: 0;
  text-align: center;
  color: ${(props) => (props["aria-disabled"] ? "#399ebf" : "#ffffff")};
  background-color: ${(props) => (props["aria-disabled"] ? "#e2f4fb" : "#399ebf")};
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:hover {
    background-color: ${(props) => (props["aria-disabled"] ? "none" : "#399ebf")};
    color: ${(props) => (props["aria-disabled"] ? "#399ebf" : "white")};
    cursor: ${(props) => (props["aria-disabled"] ? "default" : "pointer")};
  }
`;

export const InputCounter = styled("input")`
  width: 41px;
  height: 29px;
  flex-grow: 0;
  margin: 0 6px 0.4px 4.6px;
  padding: 3px 3px 2px 2px;
  border-radius: 3.6px;
  border: solid 1.2px #399ebf;
  text-align: center;
  color: #757a93;
  font-size: 12px;
  font-weight: normal;
  &:focus {
    outline: none;
  }
`;

export const ErrorStep = styled("p")`
  text-align: center;
  color: #f44336;
`;

export const LabelSlot = styled("input")`
  background: none;
  border: 1px solid #979797;
  padding: 18.5px 14px;
  height: 1.1876em;
  border-radius: 4px;
  box-sizing: content-box;
  animation-name: mui-auto-fill-cancel;
  letter-spacing: inherit;
  animation-duration: 10ms;
  -webkit-tap-highlight-color: transparent;
  &:focus {
    outline: none !important;
    border: 2px solid #399ebf;
  }
  &:hover {
    border: 2px solid #399ebf;
  }
`;
export const ContainerSelectReccurence = styled("div")`
  position: relative;
  display: flex;
  justify-content: space-between;
`;
export const SelectReccurence = styled("input")`
  background-color: #c4c4c4;
  font-weight: bold;
  text-align: center;
  text-align-last: center;
  padding: 18.5px 14px;
  border: 2px solid #c4c4c4;
  color: white;
  border-top-left-radius: 0px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0px;
  cursor: pointer;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="white" viewBox="0 0 320 512" height="1.5rem" width="1.5rem" xmlns="http://www.w3.org/2000/svg"><path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>');
  background-repeat: no-repeat;
  background-position: right 8px center;
  &:focus {
    outline: none !important;
    border: 2px solid #c4c4c4;
  }
  option {
    color: black;
    font-size: 12pt;
    background: white;
    display: flex;
    white-space: pre;
    padding: 0px 2px 1px;
    &:hover {
      background-color: red;
    }
  }
`;

export const DayContainer = styled("div")`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const DayOption = styled("button")`
  min-width: 3.5vw;
  padding: 2vh;
  border-radius: 4px;
  border: 1px solid #399ebf;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${(props) => (props["aria-selected"] ? "#FFF" : "#399ebf")};
  cursor: pointer;
  background-color: ${(props) => (props["aria-selected"] ? "#399ebf" : "transparent")};
  &:focus {
    outline: none;
  }
  position: relative;
`;
export const RightSideSamaPapserContainer = styled("div")`
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  @media (max-width: 1279px) {
    height: 30rem;
    flex-flow: wrap;
  }
  ${theme.breakpoints.down("xs")} {
    margin-left: 19px;
    width: 90%;
    margin-top: -14px;
  }
`;

export const AnimatedDiv = styled("div")`
  animation: 1.2s ${FadeInDownAnimation};
  display: flex;
  border-radius: 11px;
  background-color: ${(props) => `rgba(${props["background-color"]}, 0.2)`};
  width: auto;
  height: 111px;
  margin-top: 20px;
  align-items: center;
  padding: 10px;
  border: 1px solid #e2f4fb;
`;

export const DefaultAnimatedDiv = styled("div")`
  animation: 1.2s ${FadeInDownAnimation};
  height: 13.5rem;
  overflow-y: scroll;
  padding: 5px;
`;

export const ContainerRecapHeader = styled("div")`
  background-color: ${(props) => (props["background-color"] ? props["background-color"] : "transparent")};
  display: flex;
  width: 100%;
  position: relative;
`;

export const ContainerElements = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 20rem;
  padding-left: 5px;
  color: ${(props) => props.color || "#399ebf"};
  font-weight: bold;
`;

export const HeaderContainerElements = styled("div")`
  display: flex;
  align-items: center;
`;

export const ContainerIcon = styled("div")`
  margin: 5px;
`;

export const VehicleIcon = styled("div")`
  margin: 5px;
  border: solid 1px #399ebf;
  padding: 4px 9px;
  width: 63px;
  border-radius: 8px;
  height: 59px;
`;

export const RequestTypeTitle = styled("div")`
  width: 82%;
  margin-left: 12px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: justify;
  color: ${(props) => props.color};
`;
export const TitleSecondary = styled("div")`
  color: ${(props) => props.color};
  font-size: 12px;
  background-color: #399ebf;
  height: 23px;
  width: 23px;
  margin: auto;
  align-items: center;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: end;
  position: absolute;
  right: 10px;
  ${theme.breakpoints.down("xs")} {
    right: -4px;
  }
`;
export const DateRecap = styled("div")`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  font-style: italic;
`;

export const DateRecapCard = styled("div")`
  font-size: 12px;
  font-weight: normal;
  color: #707070;
  display: flex;
  align-items: center;
`;

export const DetailsContainer = styled("div")`
  animation: 1.2s ${FadeInDownAnimation};
  display: flex;
  border-radius: 17px;
`;

export const ContainerDetailsValue = styled("div")`
  padding: 10px;
  display: block;
`;

export const TitleField = styled("div")`
  font-size: 12px;
  font-weight: bold;
  color: ${(props) => props.color};
`;

export const FieldValue = styled("div")`
  font-size: 12px;
  font-weight: normal;
  color: #828282;
  margin-top: 7px;
`;

export const BoldValue = styled("small")`
  font-weight: bold;
`;

export const LabelField = styled("div")`
  font-size: 14px;
  font-weight: normal;
  color: #828282;
  margin-bottom: 12px;
`;

export const Filter = styled("div")`
  margin: 0px 0px 0px 10px;
  display: table-caption;
`;

export const ContainerFilter = styled("div")`
  text-align: left;
  display: flex;
`;

export const RequestListContainer = styled("div")`
  width: 100%;
  display: flex;
  flex-flow: wrap;
  padding: 0px 10px;
  height: 80vh;
  background-color: #fff;
  ${theme.breakpoints.down("xs")} {
    overflow: scroll;
    height: 72vh;
  }
`;

export const CardRequestContainer = styled("div")`
  width: 30%;
  padding: 1.5%;
  cursor: pointer;
  @media (max-width: 800px) {
    min-width: 45%;
  }
  @media (max-width: 550px) {
    min-width: 99%;
  }
`;

export const CardRequest = styled("div")`
  width: 100%;
  border: 1px solid rgb(240, 243, 244);
  background-color: white;
  border-radius: 14px;
  min-height: 180px;
  border: ${(props) => (props["aria-selected"] ? "2px solid #399ebf" : "")};
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
`;

export const HeaderCardRequest = styled("div")`
  height: 40%;
  margin: 1%;
`;

export const CenterCardRequest = styled("div")`
  height: 35%;
  margin: 1%;
  background-color: transparent;
  display: flex;
`;

export const SectionCenterCardRequest = styled("div")`
  width: 50%;
  display: flex;
  align-items: center;
  color: #707070;
  font-size: 12px;
  position: relative;
  &:hover > .reccurenceModal {
    visibility: visible;
    opacity: 1;
  }
`;

export const FooterCardRequest = styled("div")`
  height: 15%;
  margin: 1%;
  background-color: transparent;
  display: flex;
  align-items: center;
`;

export const StatusContainerRequest = styled("div")`
  display: flex;
  flex-direction: column;
`;
export const LinearEvulotionRequest = styled("div")`
  width: 90%;
  height: 4px;
  border-radius: 5px;
  background-color: #d7d7d7;
`;

export const Evolution = styled("div")`
  background-color: ${(props) => `rgb(${props["background-color"]})`};
  width: ${(props: { width?: string | number }) => props?.width};
  height: 100%;
  border-radius: 5px;
`;

export const StatusRequest = styled("div")`
  background-color: ${(props) => `rgba(${props["background-color"]}, 0.2)`};
  margin: 0px 10px;
  border-radius: 10px;
  height: 20px;
  justify-content: center;
  font-size: 12px;
  vertical-align: middle;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  color: ${(props) => `rgb(${props["background-color"]})`};
`;

export const DateTimSlotContainer = styled("div")`
  display: flex;
  width: 100%;
  margin-top: 10px;
`;

export const ContainerPrice = styled("div")`
  margin: 5px;
  width: 50%;
`;

export const RequestPrice = styled("p")`
  color: ${(props) => props.color || "#399ebf"};
  font-weight: bold;
  font-size: 18px;
`;

export const ContainerRequestDetails = styled("div")`
  margin-top: 10px;
`;

export const ContainerDetailsFile = styled("div")`
  width: 50%;
  text-align: right;
`;

export const ContainerRecapFooter = styled("div")`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const DetailsButton = styled("button")`
  height: 45px;
  margin: 0 5px 0 24px;
  border-radius: 4px;
  background-color: transparent;
  color: ${(props) => props.color};
  cursor: pointer;
  border: 1px solid ${(props) => props.color};
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  &:hover {
    background-color: ${(props) => props.color};
    color: white;
  }
`;

export const TimeLineContainer = styled("ul")`
  border-radius: 12px;
  position: relative;
  list-style-type: none;
`;

export const TimeLineItem = styled("li")`
  padding-bottom: 3rem;
  border-left: 3px solid #e4e6e9;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  display: flex;
  &:after {
    content: "";
    width: 11px;
    height: 11px;
    background: rgb(${(props) => props.color});
    border: 3px solid #e4e6e9;
    border-radius: 50%;
    position: absolute;
    left: -11px;
    top: 0px;
  }
`;

export const TimeLineItemDate = styled("div")`
  color: #828282;
  font-size: 12px;
`;

export const TimeLineEvent = styled("div")`
  color: #4f4f4f;
  margin: auto;
  background-color: ${(props) => `rgb(${props["background-color"]})`};
  @include mobile-only {
    font-size: 0.9rem;
  }
`;

export const CotainerArticlePoint = styled("div")`
  display: flex;
  justify-content: space-between;
  margin: 30px 0 0;
`;

export const DeletePoint = styled("div")`
  color: #6f6c6ec9;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #399ebf;
  height: 28px;
  width: 28px;
  padding: 2px;
  &:hover {
    color: red;
  }
`;
export const SeparatorPoint = styled("div")`
  width: 5%;
  color: #888888;
  text-align: center;
  align-items: enter;
  padding: 10px;
  font-size: 12px;
`;

interface CustomWidthProps {
  customWidth?: boolean;
}

export const SectionArticlePoint = styled("div")<CustomWidthProps>`
  width: ${({ customWidth }) => (customWidth && "100%") || "49%"};
  text-align: center;
  align-items: enter;
  border: 1px solid #bdbdbd;
  padding: 10px;
  color: #757a93;
  border: 1px solid #757a93;
  cursor: pointer;
  font-size: 14px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(142, 148, 173, 0.12);
  border-radius: 4px;
  font-family: Montserrat;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  &:hover {
    border: 1px solid #399ebf;
    color: #399ebf;
  }
`;

export const VehiclesNumbers = styled.div`
  color: #399ebf;
  font-size: 14px;
  font-weight: 700;
  position: relative;
  &:hover > .vehiclesModal {
    visibility: visible;
    opacity: 1;
  }
`;

export const VehiclesModalOnHover = styled.span`
  &.vehiclesModal {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    width: 180px;
    background-color: #fff;
    color: #399ebf;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    left: 50%;
    margin-left: -40px;
    margin-top: 10px;
    opacity: 0;
    transition: opacity 0.3s;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
`;

export const VehicleItem = styled.div`
  border-bottom: 1px #eee solid;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  color: #888;
`;

export const NumberOfVehicleSpan = styled.span`
  color: #399ebf;
`;

export const ContainerRequestList = styled("div")`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  overflow: unset;
  ${theme.breakpoints.down("xs")} {
    background-color: inherit;
  }
`;

export const ReccurenceModalOnHover = styled.span`
  &.reccurenceModal {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    width: 180px;
    background-color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    left: 0%;
    margin-left: -40px;
    margin-top: 10px;
    opacity: 0;
    transition: opacity 0.3s;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
`;

export const BadgeRequest = styled("div")`
  position: absolute;
  top: 5px;
  right: -4px;
  width: 44px;
  margin: 7px 0 9px 62px;
  padding: 5px;
  border-radius: 3px 0px 0px 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.33);
  background-color: #e44e51;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  text-align: center;
`;
